<template>
    <div class="create-module">
        <div class="top flex flex-y-center">
            <div class="top-inner flex flex-y-center" @click="back()">
                <van-icon name="arrow-left" color="#A0ACB5" size="16px" />
                <div>返回</div>
            </div>
            <div class="flex-1 top-tit">待办事项</div>
            <div class="top-inner flex flex-y-center flex-end">
                <div v-if="todoId" @click="deleteId()" class="todo-btn">删除</div>
                <div v-if="todoId">&nbsp;&nbsp;|&nbsp;&nbsp;</div>
                <div class="todo-btn" @click="saveClick">确定</div>
            </div>
        </div>
        <van-skeleton title :row="9" :loading="loading">
            <div v-for="(todoDetail, index) in todoList" :key="index" class="inner">
                <TodoItem v-model="todoList[index]" :id="`todo-item-${index}`" />
            </div>
        </van-skeleton>
        <div class="add-btn" @click="createClick">
            <van-icon name="plus" color="#fff" />添加提醒
        </div>
    </div>
</template>

<script>
import request from "@/utils/request";
import { Toast, Dialog } from 'vant'
import TodoItem from "./components/todoItem.vue";

export default {
    components: { TodoItem },
    name: 'createToDo',
    data() {
        return {
            loading: false,
            date: '',
            todoList: [
                {
                    'message': '',
                    'remindDate': '',
                    'taskContactList': [

                    ],
                },

            ]
        }
    },
    created() {
        // 获取详情列表
        this.loading = true
        this.todoId = this.$route.query.id ? this.$route.query.id : ''
        // 无id则只有新增
        if (this.todoId) {
            // 有id先回显去编辑
            this.getDetail()
        } else {
            this.loading = false
        }
    },
    methods: {
        // 回显详情
        getDetail() {
            request({
                url: `/todo/${this.todoId}`,
                method: "get",
            })
                .then((res) => {
                    this.todoList = res.data
                    this.date = this.todoList[0].remindDate
                })
                .catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                    this.loading = false
                })
        },
        // 返回
        back() {
            this.$router.go(-1)
        },
        // 点击新建
        createClick() {
            this.todoList.push(
                {
                    "message": "",
                    "remindDate": this.date,
                    "taskContactList": [],
                }
            )
        },
        // 保存
        saveClick() {
            let index = 0
            let isError = false
            for (const todoItem of this.todoList) {
                if (!todoItem.message) {
                    isError = true
                    Toast({ position: 'top', message: '请输入提醒事件' })
                    break
                } else if (!todoItem.remindDate) {
                    isError = true
                    Toast({ position: 'top', message: '请选择提醒时间' })
                    break
                }
                index++
            }
            if (isError) {
                document.getElementById(`todo-item-${index}`).scrollIntoView({ behavior: "smooth" })
                return
            }
            request({
                url: `/todo/saveTodoTask`,
                method: "post",
                data: this.todoList
            })
                .then((res) => {
                    Toast({ position: 'top', message: '保存成功' })
                    this.$router.push({
                        name: "todoList",
                    });
                })
                .catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })

                })
        },
        // 删除
        deleteId() {
            Dialog.confirm({
                message: '是否确认删除待办？',
                confirmButtonColor: '#3fb8e2'
            })
                .then(() => {

                    request({
                        url: `/todo/${this.todoId}`,
                        method: "delete",
                    })
                        .then((res) => {
                            Toast({ position: 'top', message: '删除成功' })
                            this.$router.push({ name: "todoList" });
                        })
                        .catch((error) => {
                            Toast({ position: 'top', message: error ?? '' })
                        }).finally(() => {
                            this.loading = false
                        })
                })
                .catch(() => {
                })
        }
    },
}
</script>

<style scoped lang="less">
.create-module {
    height: 100%;
    background: #f9fafc;
    overflow-y: auto;
    .top {
        width: 750px;
        height: 102px;
        background: #ffffff;
        padding: 0 30px;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
        .top-inner {
            width: 170px;
            height: 102px;
            color: #a0acb5;
            font-size: 28px;
        }
        .top-tit {
            text-align: center;
            font-size: 30px;
            font-weight: 700;
            color: #35434c;
        }
        .todo-btn {
            font-size: 28px;
            font-weight: 700;
            color: #4775d4;
        }
    }

    .inner {
        padding: 30px 30px 0 30px;
    }
    .add-btn {
        width: 166px;
        height: 50px;
        background: #2fd0d5;
        border-radius: 25px;
        font-size: 24px;
        font-weight: 400;
        color: #ffffff;
        margin: 0 auto;
        margin-top: 50px;
        margin-bottom: 200px;
        text-align: center;
        line-height: 50px;
    }
}
</style>
